import React from "react";
import { LoadingButton } from "@mui/lab";
import {
  Stack,
  useTheme,
  Button,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import { BookOpenText } from "@phosphor-icons/react";
import { ANTooltip } from "@answersnow/pkg-theme";

export default function CompanyEdit({
  onSave,
  onCancel,
  isLoading,
  disableSaveButton,
  saveTitle,
  titlePanel,
  onChange,
  data,
}: {
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  disableSaveButton: boolean;
  saveTitle: string;
  titlePanel: string;
  onChange: (name: string, onChangeType: string | null, data: any) => void;
  data: any;
}) {
  const theme = useTheme();
  return (
    <Stack p={7} gap={7}>
      <Stack flexDirection="row" gap={3} alignItems="center">
        <BookOpenText fontSize="20px" weight="duotone" color={theme.palette.primary.main} />
        <ANTooltip component={Typography} variant="subtitle1" style={{ maxWidth: "90%" }}>
          {titlePanel}
        </ANTooltip>
      </Stack>
      <Stack gap={5}>
        <Stack gap={5}>
          <TextField
            id="name"
            label="Company name"
            onChange={onChange("name", null, data)}
            value={data.name ?? ""}
            fullWidth
          />
          <FormControl>
            <FormLabel>Contract Type</FormLabel>
            <RadioGroup
              id="contract_type"
              aria-label="contract_type"
              name="contract_type"
              value={data.contract_type ?? ""}
              onChange={onChange("contract_type", null, data)}
            >
              <FormControlLabel
                value="group"
                control={<Radio color="primary" size="small" />}
                label="Group contract"
              />
              <FormControlLabel
                value="single_case"
                control={<Radio color="primary" size="small" />}
                label="Single case agreement"
              />
            </RadioGroup>
          </FormControl>
        </Stack>
        <Stack gap={3}>
          <LoadingButton disabled={disableSaveButton} onClick={onSave} loading={isLoading}>
            {saveTitle}
          </LoadingButton>
          <Button variant="text" onClick={onCancel}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
